<template>
  <fragment>
    <!-- <div class="modal-content" :id="`${id}--small-question`"> -->
    <div
      class="modal-body p-0"
      :id="`${id}--small-question`"
      :style="{ 'font-size': customFontSize }"
    >
      <div class="collapse collapse-column" ref="modalNote">
        <div class="collapse-column-left border-right">
          <slot name="note" :isShowNote="isShowNote">
            <Note
              :Question="Question"
              :Q="Question"
              :onNoteSaved="onNoteSaved"
              @close-note="closeNote"
              v-if="!ms_isDebug && notable && Question.questionId && isShowNote"
            />
          </slot>
        </div>

        <div class="collapse-column-right">
          <main class="px-5 py-3 highlight-container">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <b>
                No.PZ{{ Question.source }}
                <template v-if="Question.rawTypeName"
                  >({{ Question.rawTypeName }})</template
                >
              </b>
              <span class="small mr-n5 text-secondary"
                >来源: {{ Question.questionFrom }}</span
              >
            </div>
            <div class="mb-5" ref="allowSelect">
              <div
                class="allow-select"
                v-if="Question.detail"
                v-html="Question.detail.imageQuestionHtml"
                ref="imageQuestionHtml"
              ></div>
            </div>
            <template v-if="Question.detail">
              <template v-if="c_isQuestionTypeOP">
                <div
                  class="list-group list-group-flush border-bottom qa-option-list"
                  :class="{ checkbox: Question.noDefiniteQuestion }"
                >
                  <h6 v-if="Question.isAnswered && !isTakingExam">
                    {{
                      c_isAnsweredBlank
                        ? '您没有作答该题, '
                        : `您的回答${
                            Question.selectedOption
                              ? Question.selectedOption.toUpperCase()
                              : Question.studentAnswer.toUpperCase()
                          }, `
                    }}正确答案是: {{ Question.answer.toUpperCase() }}
                  </h6>
                  <div
                    class="list-group-item d-flex align-items-center media px-2"
                    v-show="Question.detail.imageOption0Html"
                  >
                    <span class="qa-option-level _empty-border"
                      >&nbsp;&nbsp;</span
                    >
                    <div class="media-body" ref="allowSelectOption0">
                      <span
                        class="qa-option-text font-weight-bold allow-select"
                        v-html="Question.detail.imageOption0Html"
                        ref="imageOption0Html"
                      ></span>
                    </div>
                  </div>
                  <div
                    @click.prevent="selectOption('A')"
                    :class="{
                      selected:
                        Question.selectedOption.indexOf('A') !== -1 ||
                        (Question.studentAnswer.indexOf('A') !== -1 &&
                          Question.selectedOption === '' &&
                          isTakingExam),
                      correct:
                        Question.selectedOption.indexOf('A') !== -1 &&
                        Question.answer.indexOf('A') !== -1 &&
                        Question.isAnswered &&
                        !isTakingExam,
                      incorrect:
                        ((!Question.noDefiniteQuestion &&
                          Question.selectedOption.indexOf('A') !== -1 &&
                          Question.answer.indexOf('A') === -1) ||
                          (Question.noDefiniteQuestion &&
                            ((Question.selectedOption.indexOf('A') !== -1 &&
                              Question.answer.indexOf('A') === -1) ||
                              (Question.answer.indexOf('A') !== -1 &&
                                Question.selectedOption.indexOf('A') ===
                                  -1)))) &&
                        Question.isAnswered &&
                        !isTakingExam,
                      missed:
                        Question.noDefiniteQuestion &&
                        Question.answer.indexOf('A') !== -1 &&
                        Question.selectedOption.indexOf('A') === -1 &&
                        Question.isAnswered &&
                        !isTakingExam,
                    }"
                    class="list-group-item list-group-item-action d-flex align-items-center media px-2"
                    v-if="Question.detail.imageOptionaHtml"
                  >
                    <span class="qa-option-level">A</span>
                    <div class="media-body">
                      <small class="text-danger missed">未选择</small>
                      <small class="text-danger">不正确</small>
                      <small class="text-success">正确</small>
                      <span
                        class="qa-option-text"
                        v-html="`${Question.detail.imageOptionaHtml}`"
                      ></span>
                    </div>
                  </div>

                  <div
                    @click.prevent="selectOption('B')"
                    :class="{
                      selected:
                        Question.selectedOption.indexOf('B') !== -1 ||
                        (Question.studentAnswer.indexOf('B') !== -1 &&
                          Question.selectedOption === '' &&
                          isTakingExam),
                      correct:
                        Question.selectedOption.indexOf('B') !== -1 &&
                        Question.answer.indexOf('B') !== -1 &&
                        Question.isAnswered &&
                        !isTakingExam,
                      incorrect:
                        ((!Question.noDefiniteQuestion &&
                          Question.selectedOption.indexOf('B') !== -1 &&
                          Question.answer.indexOf('B') === -1) ||
                          (Question.noDefiniteQuestion &&
                            ((Question.selectedOption.indexOf('B') !== -1 &&
                              Question.answer.indexOf('B') === -1) ||
                              (Question.answer.indexOf('B') !== -1 &&
                                Question.selectedOption.indexOf('B') ===
                                  -1)))) &&
                        Question.isAnswered &&
                        !isTakingExam,
                      missed:
                        Question.noDefiniteQuestion &&
                        Question.answer.indexOf('B') !== -1 &&
                        Question.selectedOption.indexOf('B') === -1 &&
                        Question.isAnswered &&
                        !isTakingExam,
                    }"
                    class="list-group-item list-group-item-action d-flex align-items-center media px-2"
                    v-if="Question.detail.imageOptionbHtml"
                  >
                    <span class="qa-option-level">B</span>
                    <div class="media-body">
                      <small class="text-danger missed">未选择</small>
                      <small class="text-danger">不正确</small>
                      <small class="text-success">正确</small>
                      <span
                        class="qa-option-text"
                        v-html="`${Question.detail.imageOptionbHtml}`"
                      ></span>
                    </div>
                  </div>

                  <div
                    @click.prevent="selectOption('C')"
                    :class="{
                      selected:
                        Question.selectedOption.indexOf('C') !== -1 ||
                        (Question.studentAnswer.indexOf('C') !== -1 &&
                          Question.selectedOption === '' &&
                          isTakingExam),
                      correct:
                        Question.selectedOption.indexOf('C') !== -1 &&
                        Question.answer.indexOf('C') !== -1 &&
                        Question.isAnswered &&
                        !isTakingExam,
                      incorrect:
                        ((!Question.noDefiniteQuestion &&
                          Question.selectedOption.indexOf('C') !== -1 &&
                          Question.answer.indexOf('C') === -1) ||
                          (Question.noDefiniteQuestion &&
                            ((Question.selectedOption.indexOf('C') !== -1 &&
                              Question.answer.indexOf('C') === -1) ||
                              (Question.answer.indexOf('C') !== -1 &&
                                Question.selectedOption.indexOf('C') ===
                                  -1)))) &&
                        Question.isAnswered &&
                        !isTakingExam,
                      missed:
                        Question.noDefiniteQuestion &&
                        Question.answer.indexOf('C') !== -1 &&
                        Question.selectedOption.indexOf('C') === -1 &&
                        Question.isAnswered &&
                        !isTakingExam,
                    }"
                    class="list-group-item list-group-item-action d-flex align-items-center media px-2"
                    v-if="Question.detail.imageOptioncHtml"
                  >
                    <span class="qa-option-level">C</span>
                    <div class="media-body">
                      <small class="text-danger missed">未选择</small>
                      <small class="text-danger">不正确</small>
                      <small class="text-success">正确</small>
                      <span
                        class="qa-option-text"
                        v-html="`${Question.detail.imageOptioncHtml}`"
                      ></span>
                    </div>
                  </div>

                  <div
                    @click.prevent="selectOption('D')"
                    :class="{
                      selected:
                        Question.selectedOption.indexOf('D') !== -1 ||
                        (Question.studentAnswer.indexOf('D') !== -1 &&
                          Question.selectedOption === '' &&
                          isTakingExam),
                      correct:
                        Question.selectedOption.indexOf('D') !== -1 &&
                        Question.answer.indexOf('D') !== -1 &&
                        Question.isAnswered &&
                        !isTakingExam,
                      incorrect:
                        ((!Question.noDefiniteQuestion &&
                          Question.selectedOption.indexOf('D') !== -1 &&
                          Question.answer.indexOf('D') === -1) ||
                          (Question.noDefiniteQuestion &&
                            ((Question.selectedOption.indexOf('D') !== -1 &&
                              Question.answer.indexOf('D') === -1) ||
                              (Question.answer.indexOf('D') !== -1 &&
                                Question.selectedOption.indexOf('D') ===
                                  -1)))) &&
                        Question.isAnswered &&
                        !isTakingExam,
                      missed:
                        Question.noDefiniteQuestion &&
                        Question.answer.indexOf('D') !== -1 &&
                        Question.selectedOption.indexOf('D') === -1 &&
                        Question.isAnswered &&
                        !isTakingExam,
                    }"
                    class="list-group-item list-group-item-action d-flex align-items-center media px-2"
                    v-if="Question.detail.imageOptiondHtml"
                  >
                    <span class="qa-option-level">D</span>
                    <div class="media-body">
                      <small class="text-danger missed">未选择</small>
                      <small class="text-danger">不正确</small>
                      <small class="text-success">正确</small>
                      <span
                        class="qa-option-text"
                        v-html="`${Question.detail.imageOptiondHtml}`"
                      ></span>
                    </div>
                  </div>

                  <div
                    @click.prevent="selectOption('E')"
                    :class="{
                      selected:
                        Question.selectedOption.indexOf('E') !== -1 ||
                        (Question.studentAnswer.indexOf('E') !== -1 &&
                          Question.selectedOption === '' &&
                          isTakingExam),
                      correct:
                        Question.selectedOption.indexOf('E') !== -1 &&
                        Question.answer.indexOf('E') !== -1 &&
                        Question.isAnswered &&
                        !isTakingExam,
                      incorrect:
                        ((!Question.noDefiniteQuestion &&
                          Question.selectedOption.indexOf('E') !== -1 &&
                          Question.answer.indexOf('E') === -1) ||
                          (Question.noDefiniteQuestion &&
                            ((Question.selectedOption.indexOf('E') !== -1 &&
                              Question.answer.indexOf('E') === -1) ||
                              (Question.answer.indexOf('E') !== -1 &&
                                Question.selectedOption.indexOf('E') ===
                                  -1)))) &&
                        Question.isAnswered &&
                        !isTakingExam,
                      missed:
                        Question.noDefiniteQuestion &&
                        Question.answer.indexOf('E') !== -1 &&
                        Question.selectedOption.indexOf('E') === -1 &&
                        Question.isAnswered &&
                        !isTakingExam,
                    }"
                    class="list-group-item list-group-item-action d-flex align-items-center media px-2"
                    v-if="Question.detail.imageOptioneHtml"
                  >
                    <span class="qa-option-level">E</span>
                    <div class="media-body">
                      <small class="text-danger missed">未选择</small>
                      <small class="text-danger">不正确</small>
                      <small class="text-success">正确</small>
                      <span
                        class="qa-option-text"
                        v-html="`${Question.detail.imageOptioneHtml}`"
                      ></span>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="c_isQuestionTypeQA">
                <div
                  class="border-bottom"
                  :class="{ checkbox: Question.noDefiniteQuestion }"
                >
                  <h6
                    class="text-red"
                    v-if="Question.isAnswered && !isTakingExam"
                  >
                    {{
                      c_isAnsweredBlank ? '您没有作答该题, ' : '以下是您的回答'
                    }}
                  </h6>
                  <div class="d-flex align-items-center media px-2">
                    <div class="media-body" v-if="!c_isAnsweredBlank">
                      <ckeditor
                        :editor="editor"
                        v-model="writtenText"
                        @input="writeAnswer"
                        :disabled="c_isEditorDisabled"
                        v-if="!c_isCpaQuestion"
                      ></ckeditor>
                      <sa-editor
                        v-model="writtenText"
                        @input="writeAnswer"
                        :disabled="c_isEditorDisabled"
                        v-if="c_isCpaQuestion"
                      />
                      <!-- <textarea :readonly="c_isEditorDisabled" v-model="writtenText"></textarea> -->
                      <p class="text-danger" v-if="c_isWrittenTextTooLong">
                        回答内容长度不能超过50000个有效字符。
                      </p>
                    </div>
                  </div>
                </div>
              </template>
            </template>
            <div class="mt-5" v-if="Question.isAnswered && !isTakingExam">
              <h6>数据统计(全部)</h6>
              <table class="table table-sm bg-light mb-4">
                <tbody>
                  <tr class="row no-gutters">
                    <td class="col-4 px-3">
                      做对次数:
                      <strong class="text-success">{{
                        Question.correctCount
                      }}</strong>
                    </td>
                    <td class="col-4 px-3">
                      做错次数:
                      <strong class="text-danger">{{
                        Question.wrongCount
                      }}</strong>
                    </td>
                    <td
                      class="col-4 px-3"
                      v-if="Question.correctCount + Question.wrongCount > 0"
                    >
                      正确率:
                      <strong class="text-info">
                        {{
                          Question.wrongCount + Question.correctCount > 0
                            ? (
                                (Question.correctCount /
                                  (Question.wrongCount +
                                    Question.correctCount)) *
                                100
                              ).toFixed(2)
                            : '0'
                        }}%
                      </strong>
                    </td>
                    <td class="col-4 px-3" v-else>
                      正确率:
                      <strong class="text-info">0%</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h6 v-if="!isTakingExam">数据统计(个人)</h6>
              <table v-if="!isTakingExam" class="table table-sm bg-light mb-4">
                <tbody>
                  <tr class="row no-gutters">
                    <td class="col-4 px-3">
                      做对次数:
                      <strong class="text-success">{{
                        Question.personalCorrectCount
                      }}</strong>
                    </td>
                    <td class="col-4 px-3">
                      做错次数:
                      <strong class="text-danger">{{
                        Question.personalWrongCount
                      }}</strong>
                    </td>
                    <td
                      class="col-4 px-3"
                      v-if="
                        Question.personalCorrectCount +
                          Question.personalWrongCount >
                        0
                      "
                    >
                      正确率:
                      <strong class="text-info">
                        {{
                          Question.personalWrongCount +
                            Question.personalCorrectCount >
                          0
                            ? (
                                (Question.personalCorrectCount /
                                  (Question.personalWrongCount +
                                    Question.personalCorrectCount)) *
                                100
                              ).toFixed(2)
                            : '0'
                        }}%
                      </strong>
                    </td>
                    <td class="col-4 px-3" v-else>
                      正确率:
                      <strong class="text-info">0%</strong>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h6 class="mt-5">解析</h6>
              <span
                id="small-explain"
                v-if="Question.detail.imageExplainHtml && Question.isAnswered"
                v-html="`${Question.detail.imageExplainHtml}`"
              ></span>
            </div>

            <button
              ref="highlightSelectedBtn"
              class="highlight-btn highlight-mark-btn no-select"
              aria-hidden="true"
              role="alert"
            >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAACjUlEQVRIS7WXS4hOYRjHf49bLqHkslEuS7dYyEJYWiBhQzEokgUp1waR6xgjioXJCjUWg4UFWSg7O5SahVjIQoki45bLX//p/XTMfN985xzfPOvzPr/3uf3f5wQDZJJmAWuB50BnRHzNomIguJIWAheBecBn4DTQFhHfK7yGgiXZ33LgAjA9E5SjPQWcrcAbBpY0BFgPtACTqmTyH3hDwJKGAzuAQ8CYfspn+Eng3H+DJRl0ENgJ+AL17ItL8V9gSRNT4zQBTnVe6y4NljQtNdEKoKifJ0UP9EQkaQ5wCViUN8TMd8+ArYXBkhYn6OwS0FfApoh4mBucZnQlcB6YWgL6DtgWEbd9Nhc4zejG1EgTSkC7gd3AlYhQLnCa0V1AMzC6BNQyeQxojYifuSQzRXoE2AcMKwH9lTS7OfcjIWkUMDi9MK3A2BLg6xaWiPjQ+2zVGksamUTdqd0PrLLAF4TfBbZExJtqF+4DljQIOAA4xUOBq8AeYHUB+COgKSJe1MpSNfB44AFgkbD9Bq4VgHcBGyLicX+lqQa25hq0LnMwL/w1sDkifPF+rVaN/bwd73WyHvw9sD0iOutBa86xJEMN72214BaIvUB7RSDqwaul2mN0C1ha43AWvgY4kWa1JSJ+1APWFBBJXl/aAY9ULTPcM+runwJ0RcSnvNA+qZa0DLgMTM7hxGuM57Qjx7d9PvmbakmG3QdmVHHkFHpNdce7FIZaULyyur6FLQv2/N4ElmS8WOCtQDeAl8AIYC7wFriT3ZOLknvAkqzD84GPqVEWpKjOpKgcbUMtEvSo65VWz3uAn8GnaTy+NZSYnBnsPbeymrYBh5NMKu9MlrmYwTMB/2CNAzoiwukecPsDyoHXlSxqMgkAAAAASUVORK5CYII="
                alt
              />
              <span class="sr-only">Highlight selected text</span>
            </button>
          </main>
        </div>
      </div>
    </div>
    <div class="modal-footer bg-light justify-content-between">
      <!-- <div class="modal-footer-left"> -->
      <ul class="modal-footer-right list-inline">
        <li class="list-inline-item" v-if="notable">
          <button
            type="button"
            :class="{ active: Question.haveNote }"
            class="btn btn-link text-secondary btn-note d-flex text-decoration-none collapsed"
            data-toggle="collapse"
            data-target=".collapse-column"
            aria-expanded="false"
            aria-controls="collapse-column"
            @click="toggleNote"
          >
            <i class="pz-icon icon-create mr-1"></i>
            <span class="d-none d-md-inline-block">笔记</span>
          </button>
          <!-- :class="{ active: Question.haveNote }" -->
        </li>
        <li class="list-inline-item" v-if="markable">
          <button
            type="button"
            class="btn btn-link text-secondary btn-bookmark d-flex text-decoration-none"
            :class="{
              active: Question.isMarked,
            }"
            @click="onMark"
          >
            <i class="pz-icon icon-bookmark mr-1"></i>
            <span class="d-none d-md-inline-block">收藏</span>
          </button>
        </li>
        <li class="list-inline-item">
          <button
            type="button"
            class="btn btn-link text-secondary text-decoration-none d-flex"
            :class="p_isQuestionReported && 'text-muted disabled'"
            data-toggle="collapse"
            :data-target="p_isQuestionReported ? '' : '#pz-question-report'"
            aria-expanded="false"
            aria-controls="a-modal-pop"
          >
            <i class="pz-icon icon-error mr-1"></i>
            <span class="d-none d-md-inline-block">纠错</span>
          </button>
        </li>

        <li class="list-inline-item" v-if="exerciseType === 3">
          <button
            type="button"
            class="btn btn-link text-danger text-decoration-none d-flex"
            @click="removeQuestion"
          >
            <i class="pz-icon icon-trash mr-1"></i>
            <span class="d-none d-md-inline-block">删除</span>
          </button>
        </li>

        <li class="list-inline-item" v-if="isTakingExam">
          <button
            type="button"
            class="btn btn-link text-info text-decoration-none d-flex"
            @click="submitPaper()"
          >
            <i class="pz-icon icon-description mr-1"></i>
            交卷
          </button>
        </li>

        <li class="list-inline-item" v-if="isTakingExam">
          <i class="pz-icon icon-clock text-secondary mr-1"></i>
          <span class="text-secondary">考试剩余时间: {{ surplusTime }}</span>
        </li>
      </ul>
      <ul class="modal-footer-right list-inline">
        <!-- <li class="list-inline-item" v-if="isShowStepper && tips">{{ tips }}</li> -->
        <li
          class="list-inline-item"
          v-if="isShowStepper && QuestionList.length <= 20"
        >
          <ul class="pagination-practice">
            <li
              class="pagination-item"
              v-for="(q, qIdx) in QuestionList"
              :key="`stepper-question-li-${qIdx}`"
              :class="{
                _right: q.questionStatus === 1,
                _wrong: q.questionStatus === -1,
                _active: q.questionId === Question.questionId,
              }"
            ></li>
          </ul>
        </li>
        <li v-if="isShowStepper" class="list-inline-item">
          {{ Position }}/{{ QuestionList.length }}
        </li>
        <li class="list-inline-item" v-if="isShowScantron">
          <button
            class="btn btn-link text-secondary text-decoration-none d-flex"
            type="button"
            data-toggle="collapse"
            data-target="#pz-scantron"
            aria-expanded="false"
            aria-controls="a-sheet"
          >
            <i class="pz-icon icon-sheet mr-1"></i>
            <span>{{ Position }}/{{ QuestionList.length }}</span>
          </button>
        </li>
        <template v-if="isTakingExam">
          <li
            class="list-inline-item"
            v-if="!Question.isLatest || !Question.isSubmitted"
          >
            <button
              type="button"
              @click="answer()"
              :disabled="c_isAnswerBtnDisabled"
              class="btn btn-primary px-4"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                v-if="loading"
              ></span>
              提交
            </button>
          </li>
          <li
            class="list-inline-item"
            v-if="Question.isLatest && Question.isSubmitted"
          >
            <button
              type="button"
              @click="submitPaper()"
              :disabled="aopLoading"
              class="btn btn-primary px-4"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                v-if="aopLoading"
              ></span
              >交卷
            </button>
          </li>
        </template>
        <template v-if="!isTakingExam">
          <li class="list-inline-item" v-if="!Question.isSubmitted">
            <button
              type="button"
              @click="answer()"
              :disabled="c_isAnswerBtnDisabled"
              class="btn btn-primary px-4"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                v-if="loading"
              ></span>
              提交
            </button>
          </li>
          <li
            class="list-inline-item"
            v-if="Question.isSubmitted && !Question.isLatest"
          >
            <button
              type="button"
              class="btn btn-primary px-4"
              @click="onGoToNext()"
              :disabled="aopLoading"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                v-if="aopLoading"
              ></span
              >下一题
            </button>
          </li>
          <li
            class="list-inline-item"
            v-if="Question.isLatest && Question.isSubmitted"
          >
            <button
              type="button"
              @click="onClose(exerciseType === 11 || exerciseType === 12)"
              class="btn btn-primary px-4"
              :disabled="aopLoading"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                v-if="aopLoading"
              ></span>
              {{
                exerciseType !== 11 && exerciseType !== 12 ? '结束' : '查看结果'
              }}
            </button>
          </li>
        </template>
      </ul>
    </div>
    <!-- </div> -->
  </fragment>
</template>
<script>
import $ from 'jquery';
import Swal from 'sweetalert2';
import { mapState, mapGetters } from 'vuex';
import rangy from 'rangy';
import 'rangy/lib/rangy-classapplier';

import * as constants from '@/constants';
import { mapStringToKatex } from '../../utils';
import Note from './Note.vue';

export default {
  name: 'Small',
  components: {
    Note,
    'sa-editor': () => import('@/components/SaEditor.vue'),
  },

  props: {
    id: String,
    questionFontSize: Number,
    QuestionList: {
      type: Array,
      default: () => [],
    },

    exerciseType: {
      type: Number,
      default: () => -1,
    },

    isTakingExam: Boolean,

    p_isQuestionReported: {
      type: Boolean,
      default: () => false,
    },

    Question: Object,

    notable: {
      type: Boolean,
      default: () => false,
    },

    markable: {
      type: Boolean,
      default: () => false,
    },

    isShowScantron: {
      type: Boolean,
      default: () => false,
    },

    onAnswer: {
      type: Function,
      default: () => {},
    },

    onMark: {
      type: Function,
      default: () => {},
    },

    onRemoveWrongList: {
      type: Function,
      default: () => {},
    },

    onGoToNext: {
      type: Function,
      default: () => {},
    },

    onClose: {
      type: Function,
      default: () => {},
    },

    onSetQuestion: {
      type: Function,
      default: () => {},
    },

    Position: {
      type: Number,
      default: () => 0,
    },

    isShowStepper: {
      type: Boolean,
      default: () => false,
    },

    surplusTime: {
      type: String,
      default: () => 0,
    },

    onGetAfterData: {
      type: Function,
      default: () => {},
    },

    isReadOnly: {
      type: Boolean,
      default: () => false,
    },

    onNoteSaved: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      writtenText: '',
      editor: window.ClassicEditor,
      isShowNote: false,

      applier: null,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapGetters({
      aopLoading: 'aopLoading',
      loading: 'loading',
    }),

    customFontSize: function () {
      let size = '1rem';
      switch (this.questionFontSize) {
        case 1:
          size = '1rem';
          break;
        case 2:
          size = '1.25rem';
          break;
        case 3:
          size = '1.5rem';
          break;
        default:
          size = '1rem';
      }
      return size;
    },

    c_isInEvent() {
      return constants.EVENTS_PAGE_CHUNK_NAME === this.$route.name;
    },

    c_isCpaQuestion() {
      if (this.Question.detail && this.Question.detail.questionRawType) {
        return this.Question.detail.questionRawType.indexOf('CPA') > -1;
      } else {
        return false;
      }
    },

    c_isQuestionTypeOP() {
      if (this.Question && this.Question.questionType) {
        return this.Question.questionType.indexOf('OP') !== -1;
      }
      return false;
    },

    c_isQuestionTypeQA() {
      if (this.Question && this.Question.questionType) {
        return this.Question.questionType.indexOf('QA') !== -1;
      }
      return false;
    },

    c_isNotSelectedOptionInOP() {
      return this.c_isQuestionTypeOP && !this.Question.selectedOption;
    },

    c_isQuestionTypeQAinEvent() {
      return this.c_isQuestionTypeQA && this.c_isInEvent;
    },

    c_isAnsweredBlank() {
      return (
        this.Question.isAnswered &&
        !this.Question.studentAnswer &&
        !this.Question.selectedOption
      );
    },

    c_isEditorDisabled() {
      if (this.c_isInEvent) {
        return !this.isTakingExam;
      } else {
        return this.Question.isAnswered;
      }
    },

    c_isWrittenTextTooLong() {
      if (this.writtenText && this.writtenText.length > 50000) {
        return true;
      } else {
        return false;
      }
    },

    c_isAnswerBtnDisabled() {
      return (
        this.c_isNotSelectedOptionInOP ||
        this.aopLoading ||
        this.isReadOnly ||
        this.c_isWrittenTextTooLong
      );
    },
  },

  watch: {
    Question: function (v1, v2) {
      if (v1.questionId !== v2.questionId) {
        this.setWrittenTextFromStudentAnswer(v1);
        mapStringToKatex();
        this.consoleLogAnswer(v1.answer);
      }
    },
  },

  methods: {
    selectOption(selectedOption) {
      if (this.isReadOnly) {
        return;
      }
      if (!this.Question.isAnswered) {
        this.onSetQuestion({ selectedOption });
      }
    },

    writeAnswer() {
      if (this.isReadOnly) {
        return;
      }
      if (!this.Question.isAnswered) {
        this.onSetQuestion({ selectedOption: this.writtenText });
      }
    },

    setWrittenTextFromStudentAnswer(question) {
      if (question.selectedOption) {
        this.writtenText = question.selectedOption;
      } else {
        if (question.studentAnswer && !this.isTakingExam) {
          this.writtenText = question.studentAnswer;
        } else {
          this.writtenText = '';
        }
      }
    },

    async answer() {
      if (this.Question.isAnswered && !this.c_isQuestionTypeQAinEvent) {
        return;
      }
      await this.onAnswer({
        studentAnswer: this.writtenText,
      });
      if (this.isTakingExam) {
        this.onGoToNext();
      } else {
        mapStringToKatex();
      }
    },

    removeQuestion() {
      Swal.fire({
        title: '确认删除',
        text: '确定从错题列表中直接删除该题吗?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then((result) => {
        if (result.value) {
          this.onRemoveWrongList();
        }
      });
    },

    submitPaper() {
      const _this = this;
      const undo = _this.QuestionList.filter((v) => v.questionStatus === 0);
      if (undo.length) {
        Swal.fire({
          title: '确定交卷吗？',
          text: `您还有${undo.length}道题没完成`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: '确定',
          cancelButtonText: '继续考试',
        }).then((result) => {
          if (result.value) {
            _this.onGetAfterData();
          }
        });
      } else {
        _this.onGetAfterData();
      }
    },

    toggleNote() {
      this.isShowNote = !this.isShowNote;
    },

    closeNote() {
      $(this.$refs.modalNote).collapse('hide');
      this.isShowNote = false;
    },

    consoleLogAnswer(answer) {
      if (console && this.ms_isDebug) {
        //console.clear();
        console.log('answer:', answer, '...', new Date());
      }
    },
  },

  created() {
    this.setWrittenTextFromStudentAnswer(this.Question);
  },

  mounted() {
    rangy.init();
    this.applier = rangy.createClassApplier('question-mark', {
      elementTagName: 'mark',
    });

    const allowSelectZone = this.$refs.allowSelect;
    const allowSelectOption0 = this.$refs.allowSelectOption0;

    const highlightSelectedBtn = this.$refs.highlightSelectedBtn;
    highlightSelectedBtn.onmousedown = () => {
      this.applier.toggleSelection();
      window.getSelection().removeAllRanges();
      // this.applier.undoToSelection();
      highlightSelectedBtn.style.display = 'none';
      this.$emit('save-question-rangy-mark', {
        imageQuestionHtml: this.$refs.imageQuestionHtml.innerHTML,
        imageOption0Html: this.$refs.imageOption0Html
          ? this.$refs.imageOption0Html.innerHTML
          : undefined,
        largeHtml: undefined,
        isCurrentQuestionXL: false,
        currentQuestionId: this.Question.questionId,
        currentSubQuestionIdx: -1,
      });
    };

    const bindSelect = (allowSelectZone) => {
      if (!allowSelectZone) {
        return;
      }
      allowSelectZone.onmousedown = (e1) => {
        const xy1 = e1.pageX + e1.pageY;
        let xy2 = null;
        document.onmousemove = (e2) => {
          xy2 = e2.pageX + e2.pageY;
        };
        allowSelectZone.onmouseup = (e3) => {
          // console.log(window.getSelection());
          if (xy2 && xy1 != xy2 && !window.getSelection().isCollapsed) {
            highlightSelectedBtn.style.top = e3.layerY + 'px';
            highlightSelectedBtn.style.left = e3.layerX + 'px';
            highlightSelectedBtn.style.display = 'inline-block';
          } else {
            highlightSelectedBtn.style.display = 'none';
          }
          allowSelectZone.onmouseup = null;
          document.onmousemove = null;
        };
      };
    };
    bindSelect(allowSelectZone);
    bindSelect(allowSelectOption0);

    this.consoleLogAnswer(this.Question.answer);
  },
};
</script>
<style lang="scss" scoped>
.qa-option-list {
  .incorrect {
    .text-danger.missed {
      display: none;
    }
  }
  .missed {
    .text-danger {
      display: none;
    }
    .text-danger.missed {
      display: inline-block;
    }
  }
}

.allow-select,
.allow-select * {
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  -webkit-touch-callout: text;
  -webkit-user-select: text;
  cursor: default;
}
button.highlight-btn {
  background: #2b9ed8;
  border: 1px solid #2b9ed8;
  border-radius: 4px;
  color: #fff;
  display: inline-block;
  font-family: FontAwesome, Open Sans, Source Sans Pro, sans-serif;
  font-weight: 600;
  height: 44px;
  line-height: 44px;
  overflow: visible;
  padding: 0px;
  z-index: 1000;
  width: 44px;
}

button.highlight-btn {
  -moz-box-shadow: 2px 2px 4px 0px rgba(51, 51, 51, 0.5);
  -webkit-box-shadow: 2px 2px 4px 0px rgba(51, 51, 51, 0.5);
  box-shadow: 2px 2px 4px 0px rgba(51, 51, 51, 0.5);
  display: none;
  position: absolute;
}

button.highlight-btn::after {
  border: solid transparent;
  border-bottom-color: #2b9ed8;
  border-color: rgba(43, 158, 216, 0);
  border-width: 10px;
  bottom: 100%;
  content: ' ';
  height: 0;
  left: 50%;
  margin-left: -10px;
  pointer-events: none;
  position: absolute;
  width: 0;
}

button.highlight-btn img {
  height: 30px;
  padding: 5px;
  width: 30px;
}

.highlight-container {
  position: relative;
}
</style>
